import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    IDX_RPT_EQUIPMENT_REPORT,
    IDX_RPT_EQUIPMENT_HOSPITAL_LIST,
    IDX_RPT_EQUIPMENT_DETAIL_EQP,
    IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION,
    IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS,
    IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY,
    IDX_RPT_EQUIPMENT_DETAIL_OTHERS,
    IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION,
    IDX_RPT_EQUIPMENT_EVALUATION_FORM,
    IDX_RPT_REQ_EQP_HOSPITAL_SERVICE,
    IDX_RPT_EQUIPMENT_SERVICE_LIST,
    IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE,
    IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE
} from "../../actions";

import {
    IdxRptEquipmentReportSuccess,
    IdxRptEquipmentReportError,
    IdxRptEquipmentHospitalListSuccess,
    IdxRptEquipmentHospitalListError,
    IdxRptEquipmentDetailEQPSuccess,
    IdxRptEquipmentDetailEQPError,
    IdxRptEquipmentDetailNoLocationSuccess,
    IdxRptEquipmentDetailNoLocationError,
    IdxRptEquipmentDetailOperationStatusSuccess,
    IdxRptEquipmentDetailOperationStatusError,
    IdxRptEquipmentDetailRequiredQuantitySuccess,
    IdxRptEquipmentDetailRequiredQuantityError,
    IdxRptEquipmentDetailOthersSuccess,
    IdxRptEquipmentDetailOthersError,
    IdxRptEquipmentDetailNoJustificationSuccess,
    IdxRptEquipmentDetailNoJustificationError,
    IdxRptEquipmentEvaluationFormSuccess,
    IdxRptEquipmentEvaluationFormError,
    IdxRptReqEqpHospitalServiceSuccess,
    IdxRptReqEqpHospitalServiceError,
    IdxRptEquipmentServiceListSuccess,
    IdxRptEquipmentServiceListError,
    IdxRptEquipmentTechnologyTypeSuccess,
    IdxRptEquipmentTechnologyTypeError,
    IdxRptReqEquipmentByTechnologyTypeSuccess,
    IdxRptReqEquipmentByTechnologyTypeError
} from '../../actions';

export function* watchIdxRptEquipmentReport() {
    yield takeEvery(IDX_RPT_EQUIPMENT_REPORT, onIdxRptEquipmentReport);
}

export function* watchIdxRptEquipmentHospitalList() {
    yield takeEvery(IDX_RPT_EQUIPMENT_HOSPITAL_LIST, onIdxRptEquipmentHospitalList);
}

export function* watchIdxRptEquipmentDetailEQP() {
    yield takeEvery(IDX_RPT_EQUIPMENT_DETAIL_EQP, onIdxRptEquipmentDetailEQP);
}

export function* watchIdxRptEquipmentDetailNoLocation() {
    yield takeEvery(IDX_RPT_EQUIPMENT_DETAIL_NO_LOCATION, onIdxRptEquipmentDetailNoLocation);
}

export function* watchIdxRptEquipmentDetailOperationStatus() {
    yield takeEvery(IDX_RPT_EQUIPMENT_DETAIL_OPERATION_STATUS, onIdxRptEquipmentDetailOperationStatus);
}

export function* watchIdxRptEquipmentDetailRequiredQuantity() {
    yield takeEvery(IDX_RPT_EQUIPMENT_DETAIL_REQUIRED_QUANTITY, onIdxRptEquipmentDetailRequiredQuantity);
}

export function* watchIdxRptEquipmentDetailOthers() {
    yield takeEvery(IDX_RPT_EQUIPMENT_DETAIL_OTHERS, onIdxRptEquipmentDetailOthers);
}

export function* watchIdxRptEquipmentDetailNoJustification() {
    yield takeEvery(IDX_RPT_EQUIPMENT_DETAIL_NO_JUSTIFICATION, onIdxRptEquipmentDetailNoJustification);
}

export function* watchIdxRptEquipmentEvaluationForm() {
    yield takeEvery(IDX_RPT_EQUIPMENT_EVALUATION_FORM, onIdxRptEquipmentEvaluationForm);
}

export function* watchIdxRptReqEqpHospitalService() {
    yield takeEvery(IDX_RPT_REQ_EQP_HOSPITAL_SERVICE, onIdxRptReqEqpHospitalService);
}

export function* watchIdxRptEquipmentServiceList() {
    yield takeEvery(IDX_RPT_EQUIPMENT_SERVICE_LIST, onIdxRptEquipmentServiceList);
}

export function* watchIdxRptEquipmentTechnologyType() {
    yield takeEvery(IDX_RPT_EQUIPMENT_TECHNOLOGY_TYPE, onIdxRptEquipmentTechnologyType);
}

export function* watchIdxRptReqEquipmentByTechnologyType() {
    yield takeEvery(IDX_RPT_REQ_EQUIPMENT_BY_TECHNOLOGY_TYPE, onIdxRptReqEquipmentByTechnologyType);
}

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onIdxRptEquipmentReportAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxassessment/listreport', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptEquipmentHospitalListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxassessment/hospital', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptEquipmentDetailEQPAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxassessment/equipmentbyhospital', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptEquipmentDetailNoLocationAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxassessment/nolocation', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptEquipmentDetailOperationStatusAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxassessment/operationstatus', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptEquipmentDetailRequiredQuantityAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxassessment/requiredquantity', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptEquipmentDetailOthersAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'idxassessment/others', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptEquipmentDetailNoJustificationAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'idxassessment/nojustification', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptEquipmentEvaluationFormAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'idxassessment/detailevaluationform', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptReqEqpHospitalServiceAsync = async (payload) => {
    let token = await getToken(authFB);

    const response = await fetch(servicePath + 'idxassessment/eqphospitalservice', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptEquipmentServiceListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxassessment/service', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptEquipmentTechnologyTypeAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxassessment/technologytype', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptReqEquipmentByTechnologyTypeAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxassessment/eqprequiredbytechnologytype', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};


function* onIdxRptEquipmentReport(data) {
    try {
        const response = yield call(onIdxRptEquipmentReportAsync, data.payload);
        yield put(IdxRptEquipmentReportSuccess(response.data));
    } catch (error) {
        yield put(IdxRptEquipmentReportError(error));
    }
}

function* onIdxRptEquipmentHospitalList(data) {
    try {
        const response = yield call(onIdxRptEquipmentHospitalListAsync, data.payload);
        yield put(IdxRptEquipmentHospitalListSuccess(response.data));
    } catch (error) {
        yield put(IdxRptEquipmentHospitalListError(error));
    }
}

function* onIdxRptEquipmentDetailEQP(data) {
    try {
        const response = yield call(onIdxRptEquipmentDetailEQPAsync, data.payload);
        yield put(IdxRptEquipmentDetailEQPSuccess(response.data));
    } catch (error) {
        yield put(IdxRptEquipmentDetailEQPError(error));
    }
}

function* onIdxRptEquipmentDetailNoLocation(data) {
    try {
        const response = yield call(onIdxRptEquipmentDetailNoLocationAsync, data.payload);
        yield put(IdxRptEquipmentDetailNoLocationSuccess(response.data));
    } catch (error) {
        yield put(IdxRptEquipmentDetailNoLocationError(error));
    }
}

function* onIdxRptEquipmentDetailOperationStatus(data) {
    try {
        const response = yield call(onIdxRptEquipmentDetailOperationStatusAsync, data.payload);
        yield put(IdxRptEquipmentDetailOperationStatusSuccess(response.data));
    } catch (error) {
        yield put(IdxRptEquipmentDetailOperationStatusError(error));
    }
}

function* onIdxRptEquipmentDetailRequiredQuantity(data) {
    try {
        const response = yield call(onIdxRptEquipmentDetailRequiredQuantityAsync, data.payload);
        yield put(IdxRptEquipmentDetailRequiredQuantitySuccess(response.data));
    } catch (error) {
        yield put(IdxRptEquipmentDetailRequiredQuantityError(error));
    }
}

function* onIdxRptEquipmentDetailOthers(data) {
    try {
        const response = yield call(onIdxRptEquipmentDetailOthersAsync, data.payload);
        yield put(IdxRptEquipmentDetailOthersSuccess(response.data));
    } catch (error) {
        yield put(IdxRptEquipmentDetailOthersError(error));
    }
}

function* onIdxRptEquipmentDetailNoJustification(data) {
    try {
        const response = yield call(onIdxRptEquipmentDetailNoJustificationAsync, data.payload);
        yield put(IdxRptEquipmentDetailNoJustificationSuccess(response.data));
    } catch (error) {
        yield put(IdxRptEquipmentDetailNoJustificationError(error));
    }
}

function* onIdxRptEquipmentEvaluationForm(data) {
    try {
        const response = yield call(onIdxRptEquipmentEvaluationFormAsync, data.payload);
        yield put(IdxRptEquipmentEvaluationFormSuccess(response.data));
    } catch (error) {
        yield put(IdxRptEquipmentEvaluationFormError(error));
    }
}

function* onIdxRptReqEqpHospitalService(data) {
    try {
        const response = yield call(onIdxRptReqEqpHospitalServiceAsync, data.payload);
        yield put(IdxRptReqEqpHospitalServiceSuccess(response.data));
    } catch (error) {
        yield put(IdxRptReqEqpHospitalServiceError(error));
    }
}

function* onIdxRptEquipmentServiceList(data) {
    try {
        const response = yield call(onIdxRptEquipmentServiceListAsync, data.payload);
        yield put(IdxRptEquipmentServiceListSuccess(response.data));
    } catch (error) {
        yield put(IdxRptEquipmentServiceListError(error));
    }
}

function* onIdxRptEquipmentTechnologyType(data) {
    try {
        const response = yield call(onIdxRptEquipmentTechnologyTypeAsync, data.payload);
        yield put(IdxRptEquipmentTechnologyTypeSuccess(response.data));
    } catch (error) {
        yield put(IdxRptEquipmentTechnologyTypeError(error));
    }
}

function* onIdxRptReqEquipmentByTechnologyType(data) {
    try {
        const response = yield call(onIdxRptReqEquipmentByTechnologyTypeAsync, data.payload);
        yield put(IdxRptReqEquipmentByTechnologyTypeSuccess(response.data));
    } catch (error) {
        yield put(IdxRptReqEquipmentByTechnologyTypeError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchIdxRptEquipmentReport),
        fork(watchIdxRptEquipmentHospitalList),
        fork(watchIdxRptEquipmentDetailEQP),
        fork(watchIdxRptEquipmentDetailNoLocation),
        fork(watchIdxRptEquipmentDetailOperationStatus),
        fork(watchIdxRptEquipmentDetailRequiredQuantity),
        fork(watchIdxRptEquipmentDetailOthers),
        fork(watchIdxRptEquipmentDetailNoJustification),
        fork(watchIdxRptEquipmentEvaluationForm),
        fork(watchIdxRptReqEqpHospitalService),
        fork(watchIdxRptEquipmentServiceList),
        fork(watchIdxRptEquipmentTechnologyType),
        fork(watchIdxRptReqEquipmentByTechnologyType)
    ]);
}
